var _path, _path2, _circle, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMp4({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00525 0.319519H15.8724L23.6849 8.13202V29.9992C23.6849 30.9225 22.9285 31.6789 22.0052 31.6789H2.00525C1.08198 31.6789 0.325562 30.9225 0.325562 29.9992V1.99921C0.325562 1.07594 1.08198 0.319519 2.00525 0.319519Z",
    fill: "white",
    stroke: "#8B8B8A",
    strokeWidth: 0.64
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2302 7.67889H18.0037C17.0804 7.67889 16.324 6.92248 16.324 5.99921V0.772644L23.2302 7.67889Z",
    stroke: "#8B8B8A",
    strokeWidth: 0.64
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.0059,
    cy: 16.7992,
    r: 5.975,
    fill: "#242729",
    stroke: "url(#paint0_linear_15189_23457)",
    strokeWidth: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1661 14.014C10.1333 13.9949 10.0915 13.9939 10.0577 14.0131C10.0248 14.0317 10.0039 14.0669 10.0039 14.1051V16.7988V19.4929C10.0039 19.5316 10.0248 19.5664 10.0577 19.585C10.0915 19.6046 10.1333 19.6036 10.1661 19.584L14.7516 16.8899C14.7845 16.8713 14.8039 16.8365 14.8039 16.7988C14.8039 16.7621 14.7845 16.7268 14.7516 16.7082L10.1661 14.014Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15189_23457",
    x1: 7.40588,
    y1: 13.1992,
    x2: 16.0059,
    y2: 21.1992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB904E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F67AE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMp4);
export default __webpack_public_path__ + "static/media/Mp4.8d4e385d272e2cafb0ab1cfe8984ef01.svg";
export { ForwardRef as ReactComponent };